<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <h1 class="page-title pull-left">Arboviral</h1>
        <div class="pull-right">
          <button class="pointer btn btn-lg btn-primary" v-on:click="form.showEdit({title: 'Add Arboviral Data'})">Add Data</button>
        </div>
      </div>
    </div>

    <div class="panel">
      <search-fields :form="form" :fields="searchFieldsList"></search-fields>

      <loading :working="form.working()"></loading>

      <div class="panel-body" v-if="!form.working()">
        <div class="col-xs-12 table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Sample No.</th>
                <th>Trap</th>
                <th>Date</th>
                <th>Performed By</th>
                <th>Pool No.</th>
                <th>Pool Size</th>
                <th>Assay Type</th>
                <th>Result</th>
                <th>Work Status</th>
                <th width="170"></th>
              </tr>
            </thead>
            <tbody>

            <tr v-for="item in form.list">
              <td>{{ item.attributes.sampleNumber }}</td>
              <td>{{ item.attributes.trap.number }}</td>
              <td><span v-if="item.attributes.dateTested">{{ item.attributes.dateTested | datetime }}</span></td>
              <td>{{ item.attributes.performedBy }}</td>
              <td>{{ item.attributes.poolNumber }}</td>
              <td>{{ item.attributes.poolSize }}</td>
              <td>{{ assayName(item.attributes.assayId) }}</td>
              <td>{{ resultName(item.attributes.resultId) }}</td>
              <td>{{ item.attributes.workStatus }}</td>

              <td>
                <a class="pointer text-primary" v-on:click="showEdit(item)">Add Data</a>
                <br>
                <router-link :to="{ name: 'data-adult-surveillance-details', params: { id: item.attributes.adultSurveillanceId }}">Sample Details</router-link>
                <br>
                <a class="pointer text-danger" v-on:click="form.destroy(item.id)">Delete</a>
              </td>
            </tr>


            </tbody>
            <pager :form="form"></pager>
          </table>
        </div>
      </div>
    </div>

    <site-form :form="form"></site-form>

  </div>
</template>

<script>
  import ArboviralService from '@/services/ArboviralService';
  import Form from '@/utils/form';
  import loader from '@/utils/loader';
  import siteForm from '@/components/forms/arboviral';
  import pager from '@/components/forms/pager';
  import searchFields from '@/components/search_fields';
  import loading from '@/components/loading';

  import store from '@/store';

  export default {
    name: 'arboviral',

    components: {
      pager,
      searchFields,
      siteForm,
      loading
    },

    props: ['id'],

    data() {
      return {
        searchFieldsList: {'trap_number': 'Trap #', 'pool_number': 'Pool #', 'location': 'Location'},
        form: new Form(
          ArboviralService,
          {
            sampleNumber: null,
            trap: [],
            dateTested: null,
            performedBy: null,
            poolNumber: null,
            poolSize: null,
            assayId: null,
            resultId: null,
            workStatus: 0,
          })
      }
    },

    methods: {
      assayName(id) {
        return this.$store.getters.assaysNameById(id);
      },
      resultName(id) {
        return this.$store.getters.resultsNameById(id);
      },
      showEdit(item) {
        this.form.showEdit({ id: item.id, title: 'Add Arboviral Data' });
        this.$forceUpdate();
      }
    },

    mounted() {
      loader.lookups()
        .then(() => {
          this.form.getList();
        });

      if (this.$props.id) {
        this.form.showEdit();
        this.form.data.adult_surveillance_id = this.$props.id;
      }
    }

  }
</script>

<style lang="scss">

</style>